<template>
  <div class="search_container">
    <button
      class="search_icon_btn"
      @click="handleSearch"
    >
      <img
        :src="
          require('@/assets/components/FigmaDDSSlicePNG6386d65a5fbe53208e6fb2fe184c676e.png')
        "
        alt="Search icon"
        class="search_icon"
      />
    </button>
    <input
      type="text"
      v-model="searchQuery"
      :placeholder="props.placeholder"
      class="search_input"
      @input="handleInput"
      @keydown.enter="handleSearch"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />
    <button
      v-if="searchQuery && (isFocused || showClearBtn)"
      class="clear_btn"
      @click="handleClear"
    >
      <img
        :src="require('@/assets/components/clear-icon.svg')"
        alt="Clear icon"
        class="clear_icon"
      />
    </button>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from "vue"

const props = defineProps({
  placeholder: {
    type: String,
    default: "请输入搜索内容",
  },
  debounceDelay: {
    type: Number,
    default: 300,
  },
  initialValue: {
    type: String,
    default: "",
  },
})

const emit = defineEmits(["search", "input", "clear"])

// Reactive state
const searchQuery = ref(props.initialValue)
const isFocused = ref(false)
const showClearBtn = ref(false)

// Methods
const handleInput = () => {
  showClearBtn.value = searchQuery.value.length > 0
  emit("input", searchQuery.value)
}

const handleSearch = () => {
  if (searchQuery.value.trim()) {
    emit("search", searchQuery.value.trim())
  }
}

const handleClear = () => {
  searchQuery.value = ""
  showClearBtn.value = false
  emit("clear")
  emit("input", "")
}
</script>

<style scoped>
.search_container {
  position: relative;
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  width: 10.06vw;
  height: 1.67vw;
  border-left: 1px solid rgba(209, 209, 209, 1);
  border-top: 1px solid rgba(209, 209, 209, 1);
  border-right: 1px solid rgba(209, 209, 209, 1);
  border-bottom: 0.06vw solid rgba(97, 97, 97, 1);
}

.search_input {
  flex: 1;
  height: 100%;
  padding: 0 0.2vw 0 0.2vw;
  border: none;
  outline: none;
  font-size: 0.73vw;
  color: #000;
  background: transparent;
  width: 5.8vw;
  overflow: hidden;
}

.search_input::placeholder {
  color: rgba(112, 112, 112, 1);
}

.search_icon_btn {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0 0.3vw;
}

.search_icon {
  width: 1vw;
  height: 1vw;
  margin-top: 0.24vw;
}

.clear_btn {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0 0.7vw 0 0;
}

.clear_icon {
  width: 1vw;
  height: 1vw;
}
</style>
